import { Routes, Route, useLocation } from "react-router-dom"
import { useEffect } from "react"
import ToolsLayout from "../components/tools/ToolsLayout"
import ToolsHome from "../components/tools/ToolsHome"
import YanbalCalc from "../components/tools/yanbal-calc"
import YanbalCards from "../components/tools/yanbal-cards"

const ToolsPage = () => {
  const location = useLocation()

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <Routes>
      <Route path="/" element={<ToolsLayout />}>
        <Route index element={<ToolsHome />} />
        <Route path="yanbal-calc" element={<YanbalCalc />} />
        <Route path="yanbal-cards" element={<YanbalCards />} />
      </Route>
    </Routes>
  )
}

export default ToolsPage
